import React, { useEffect, useRef, useState } from "react";
import styles from "./CreateInstructionsChecklist.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../components/input/InputField";
import Button from "../../../components/button/Button";
import { useTranslation } from "react-i18next";
import { AiOutlinePlus } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import pickImage from "../../../assets/pickImage.png";
import { Collapse, List } from "antd";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import { IMG_URL } from "../../../store/Apis";
import AlertAction from "../../../store/Actions/AlertActions";
import LocationMiddleware from "../../../store/Middlewares/LocationMiddleware";

function CreateInstructionsChecklist() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const data = state
  console.log('data', data)
  const { t, i18n } = useTranslation();
  const [ItemImage, setItemImage] = useState();
  const [MultipleItems, setMultipleItems] = useState([]);
  const hiddenFileInput = useRef(null);
  const [Toggle, setToggle] = useState(true);
  const { Panel } = Collapse;

  const dispatch = useDispatch();
  const [ItemName, setItemName] = useState('')
  const [ItemDetail, setItemDetail] = useState('')
  const [CheckListName, setCheckListName] = useState(data?.name);
  const [AddItem, setAddItem] = useState('');
  const [itemDescription, setItemDescription] = useState('');
  const [AddedItem, setAddedItem] = useState();
  const [AddedList, setAddedList] = useState();
  // const [pickImage, setpickImage] = useState(null);
  const [editImage, seteditImage] = useState(null);
  const [CameraAndLibraryModalVisible, setCameraAndLibraryModalVisible] =
    useState(false);

  const [RefreshList, setRefreshList] = useState(false);
  const [CleanerList, setCleanerList] = useState([]);
  const [selectedCleaner, setselectedCleaner] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  console.log('AddedItem', AddedItem)
  useEffect(() => {
    setAddedItem(data?.items)

  }, [])


  const onPressAddItem = () => {
    if (!AddItem) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Type Item First.' }))
      // Alert.alert('Note', 'Type Item First.');
    } else if (!itemDescription) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Type Item Description.' }))
      // Alert.alert('Note', 'Type Item Description.');
    } else {
      AddedItem.push({
        name: AddItem,
        // id: AddedItem.length,
        description: itemDescription,
        attachment: ItemImage,
      });
      setAddItem('');
      setItemDescription('');
      setItemImage();
      // eslint-disable-next-line no-unused-expressions
      hiddenFileInput.current.value == '';
      setRefreshList(!RefreshList);
    }
  };

  const CreateChecklist = () => {
    if (!CheckListName) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please Enter Checklist Name' }))
      // Alert.alert('Note', 'Please Enter Checklist Name');
    }
    else if (AddedItem.length == 0) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Atleast one Item is required' }))
      // Alert.alert('Note', 'Atleast one Item is required');
    }
    else {

      let arraydata = []
      for (let i = 0; i < AddedItem.length; i++) {
        if (typeof (AddedItem[i]?.attachment) == 'string') {
          arraydata.push({
            // attachment: null,
            name: AddedItem[i]?.name,
            id: AddedItem[i]?.id,
            description: AddedItem[i]?.description,
          });
        } else {
          arraydata.push({
            attachment: AddedItem[i]?.attachment,
            name: AddedItem[i]?.name,
            id: AddedItem[i]?.id,
            description: AddedItem[i]?.description,
          });
        }
      }
      let userData = {
        name: CheckListName,
        id: data?.id,
        AddedItem: arraydata,
      };

      console.log("final", userData);

      dispatch(LocationMiddleware.updateChecklist(userData))
        .then(data => {
          dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
          // navigate('/WorkOrderRequest/Customers')
          navigate(-2)
          // Alert.alert('Note', data?.message, [
          //     { text: 'OK', onPress: () => navigation.goBack() },
          // ]);
        })
        .catch(err => console.log(err));
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  // const onClickAddItem = () => {
  //   if (!ItemName || !ItemDescription || !ItemImage) {
  //     // dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
  //     alert(t("All feilds are required!"));
  //   } else if (!checklistName) {
  //     alert(t("Cheklist Name is required"));
  //   } else {
  //     MultipleItems.push({
  //       id: MultipleItems?.length == 0 ? 0 : MultipleItems?.length,
  //       item_name: ItemName,
  //       item_description: ItemDescription,
  //       item_image: ItemImage,
  //     });
  //     setItemName("");
  //     setItemDescription("");
  //     setItemImage("");
  //   }
  // };

  const removeItems = (index, id) => {
    console.log('addedItem',AddedItem)
    AddedItem.splice(index, 1)
    setAddedItem(AddedItem)
    setRefreshList(!RefreshList);
    
  };

  const renderItem = (item, index) => {
    return (
      <Collapse size="large" bordered={false} className={styles.dropdown}>
        <Panel
          showArrow={false}
          header={
            <div className={styles.headerMainCont}>
              <div className={styles.headerSubCont}>
                <div >
                  {Toggle?.id != item?.id ? (
                    <IoIosArrowDown
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(item)}
                    />
                  ) : (
                    <IoIosArrowUp
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(null)}
                    />
                  )}
                </div>
                <div className={styles.headerSubDiv}>
                  <text className={styles.text_x} style={{ marginLeft: "5%" }}>
                    {item?.name}
                  </text>
                </div>
              </div>
              <div>
                <MdDelete onClick={() => removeItems(index, item?.id)} size={25} className={styles.delIcon} />
              </div>
            </div>
          }
          key="1"
          className={styles.dropdown_header}
        >
          <div className={styles.flexC}>
            <text className={styles.text_x}>{item?.description}</text>
            {item?.attachment ?
              <img
                src={item?.attachment?.name ? URL.createObjectURL(item?.attachment) : IMG_URL + item?.attachment}
                className={styles.dropdown_item_image}
              />
              : null}
          </div>
        </Panel>
      </Collapse>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <div className={styles.flex}>
        <h1 className={styles.heading}>{t("Checklist")}</h1>
        {/* <img src={step} className={styles.step_image} /> */}
      </div>

      <div className={styles.wrap_input}>
        <InputField
          label={t("Checklist Name")}
          placeholder={t("Checklist Name")}
          value={CheckListName}
          onChange={(e) => setCheckListName(e.target.value)}
        />
      </div>

      <div className={styles.flexD}>
        <div className={styles.flexC}>
          <text className={styles.sub_heading}>{t("Add Items")}</text>
          <button className={styles.add_button} onClick={onPressAddItem}>
            <AiOutlinePlus className={styles.add_icon} />
          </button>
        </div>

        <div className={styles.wrap_input}>
          <InputField
            placeholder={t("Item Name")}
            onChange={(e) => setAddItem(e.target.value)}
            value={AddItem}
          />
        </div>

        <textarea
          placeholder={t("Item Description")}
          onChange={(e) => setItemDescription(e.target.value)}
          value={itemDescription}
          className={styles.text_box}
          rows={7}
          cols={7}
        ></textarea>
      </div>

      <div className={styles.sub_headingx}>
        <text>{t("Add Image")}</text>
      </div>

      <div className={styles.imgMainCont}>
        <div>
          <img
            src={ItemImage ? URL.createObjectURL(ItemImage) : pickImage}
            style={{ width: "100%", height: "100%" }}
          />
        </div>

        <div style={{ marginTop: '5%' }}>
          <button className={styles.image_add_button} onClick={handleClick}>
            <AiOutlinePlus className={styles.add_icon} />
          </button>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setItemImage(e.target.files[0])}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </div>
      </div>

      <List dataSource={AddedItem} renderItem={renderItem} />

      <div className={styles.button}>
        <Button text={t("Add Checklist")} onClick={() => {CreateChecklist()}} />
      </div>
    </div>
  );
}

export default CreateInstructionsChecklist;
